import type { TFunction } from "i18next";
import type { Schema } from "@/shared/components/Form/types";

// Лейблы латиницей: это названия полей в панели Bunny, переводить их
// значит мешать искать.
export function makeBunnySettingsSchema(t: TFunction): Schema {
  return {
    libraryId: {
      type: "text",
      label: t("bunnySettings.form.libraryIdLabel"),
      required: true,
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    cdnHostname: {
      type: "text",
      label: t("bunnySettings.form.cdnHostnameLabel"),
      required: true,
      xs: 12,
      sm: 6,
      fullWidth: true,
    },
    apiKey: {
      type: "password",
      label: t("bunnySettings.form.apiKeyLabel"),
      required: true,
      xs: 12,
      fullWidth: true,
    },
    readOnlyApiKey: {
      type: "password",
      label: t("bunnySettings.form.readOnlyApiKeyLabel"),
      required: true,
      xs: 12,
      fullWidth: true,
    },
    cdnTokenKey: {
      type: "password",
      label: t("bunnySettings.form.cdnTokenKeyLabel"),
      required: true,
      xs: 12,
      fullWidth: true,
    },
    accountApiKey: {
      type: "password",
      label: t("bunnySettings.form.accountApiKeyLabel"),
      helperText: t("bunnySettings.form.accountApiKeyHelper"),
      required: false,
      xs: 12,
      fullWidth: true,
    },
  };
}
